import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-facility-or-district-popup",
	templateUrl: "./facility-or-district-popup.component.html",
	styleUrls: ["./facility-or-district-popup.component.css"],
})
export class FacilityOrDistrictPopupComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef) {}

	ngOnInit(): void {
		this.FacilityID = this.dialogConfig.data.FacilityID;
		this.FacilityName = this.dialogConfig.data.FacilityName;
	}

	//////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////

	FacilityID: number = -1;
	FacilityName: string = "";

	//////////////////////////////////////////////////////

	//////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////

	onFacility() {
		this.ref.close({
			Success: true,
			FacilityID: this.FacilityID,
		});
	}

	onDistrict() {
		this.ref.close({
			Success: true,
			FacilityID: -1,
		});
	}

	onClose() {
		this.ref.close({
			Success: false,
			FacilityID: -1,
		});
	}

	//////////////////////////////////////////////////////
}
